import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import CurrencySelector from './CurrencySelector';
import { useSiteSettings } from '../services/siteSettingsService';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { settings } = useSiteSettings();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { id: 'home', label: 'Accueil', path: '/' },
    { id: 'services', label: 'Services', path: '/services' },
    { id: 'metiers', label: 'Métiers', path: '/metiers' },
    { id: 'valeurs', label: 'Valeurs', path: '/valeurs' },
    { id: 'technologies', label: 'Technologies', path: '/technologies' },
    { id: 'contact', label: 'Contact', path: '/contact' }
  ];
  const primaryCtaIsExternal = /^(https?:\/\/|mailto:|tel:)/i.test(settings.primaryCtaPath);

  return (
    <>
      <motion.header
        className={`sticky top-0 z-50 bg-white/95 backdrop-blur-sm transition-shadow duration-300 ${
          isScrolled ? 'shadow-lg' : ''
        }`}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="text-2xl font-bold text-neon-orange">
              {settings.brandShortName}
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.id}
                  to={link.path}
                  className="text-gray-700 hover:text-neon-orange transition-colors"
                >
                  {link.label}
                </Link>
              ))}
              
              <CurrencySelector />

              {primaryCtaIsExternal ? (
                <a href={settings.primaryCtaPath} className="cta-button">
                  Demander mon diagnostic
                </a>
              ) : (
                <Link to={settings.primaryCtaPath} className="cta-button">
                  Demander mon diagnostic
                </Link>
              )}
            </div>

            <button
              type="button"
              className="grid min-h-11 min-w-11 place-items-center rounded-xl text-gray-900 transition hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-neon-orange/20 md:hidden"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label={isMobileMenuOpen ? 'Fermer le menu principal' : 'Ouvrir le menu principal'}
              aria-expanded={isMobileMenuOpen}
              aria-controls="mobile-navigation"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
                />
              </svg>
            </button>
          </div>
        </nav>
      </motion.header>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-black/50 z-40" onClick={() => setIsMobileMenuOpen(false)} />
      )}
      
      {isMobileMenuOpen && (
        <div
          id="mobile-navigation"
          className="fixed right-0 top-0 z-50 h-full w-4/5 max-w-sm bg-white shadow-2xl"
        >
          <div className="flex justify-end p-4">
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Fermer le menu principal"
              className="grid min-h-11 min-w-11 place-items-center rounded-xl transition hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-neon-orange/20"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className="w-full text-left px-6 py-4 text-lg hover:bg-gray-50 transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <div className="px-6 py-4">
              {primaryCtaIsExternal ? (
                <a
                  href={settings.primaryCtaPath}
                  className="cta-button w-full text-center"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Demander mon diagnostic
                </a>
              ) : (
                <Link
                  to={settings.primaryCtaPath}
                  className="cta-button w-full text-center"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Demander mon diagnostic
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
